import StartNode from "./startNode";
import EndNode from "./endNode";
import ConversationNode from "./conversationNode";
import CustomCallTransferNode from "./callTransferNode";
import CustomConnectorNode from "./connectorNode";

export const initialNodes = [
  {
    id: "1",
    type: "begin",
    position: {
      x: 0,
      y: 43,
    },
    targetPosition: "left",
    sourcePosition: "right",
    measured: {
      width: 72,
      height: 27,
    },
    selected: false,
    dragging: false,
  },
];

export const nodeTypes = {
  connector: CustomConnectorNode,
  conversation: ConversationNode,
  callTransfer: CustomCallTransferNode,
  begin: StartNode,
  end: EndNode,
};
